const pulseRadius = radius => ({
  borderTopLeftRadius: radius,
  borderTopRightRadius: radius,
  borderBottomLeftRadius: radius,
  borderBottomRightRadius: radius,
})

const noBorder = {
  borderTopWidth: 0,
  borderBottomWidth: 0,
  borderLeftWidth: 0,
  borderRightWidth: 0,
}

const pulseGroupState = ($theme, error, missing) => {
  if (error)
    return { backgroundColor: $theme.colors.dangerPulseBg, boxShadow: `inset 0 0 0 1px ${$theme.colors.dangerPulse}` }
  if (missing) {
    return { backgroundColor: $theme.colors.missPulseBg, boxShadow: `inset 0 0 0 1px ${$theme.colors.missPulseBorder}` }
  }
  return { backgroundColor: $theme.colors.bgPulseTrack, boxShadow: 'none' }
}

export const SDButtonGroupPulseOverrides = (direction, error, missing) => ({
  Root: {
    style: ({ $theme }) => ({
      flexDirection: direction ?? 'row',
      flexWrap: 'wrap',
      gap: '4px',
      paddingTop: '4px',
      paddingBottom: '4px',
      paddingLeft: '4px',
      paddingRight: '4px',
      marginLeft: 0,
      ...noBorder,
      ...pulseRadius('10px'),
      ...pulseGroupState($theme, error, missing),
    }),
  },
})

const pulseSegmentColors = ($theme, $isSelected, $disabled) => {
  if ($disabled) {
    return {
      color: $theme.colors.textPulseFaint,
      backgroundColor: $isSelected ? $theme.colors.bgPulseCanvas : 'transparent',
      boxShadow: 'none',
    }
  }
  return {
    color: $isSelected ? $theme.colors.textPulseStrong : $theme.colors.textPulseLabel,
    backgroundColor: $isSelected ? $theme.colors.white : 'transparent',
    boxShadow: $isSelected ? $theme.lighting.shadowPulseSegment : 'none',
  }
}

export const SDButtonGroupButtonPulseOverrides = () => ({
  BaseButton: {
    style: ({ $theme, $disabled, $isSelected }) => ({
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 'auto',
      height: '28px',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: '10px',
      paddingRight: '10px',
      marginLeft: 0,
      marginRight: 0,
      ...noBorder,
      ...pulseRadius('7px'),
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: $isSelected ? 600 : 500,
      whiteSpace: 'nowrap',
      ...pulseSegmentColors($theme, $isSelected, $disabled),
      ':hover': {
        color: $disabled ? $theme.colors.textPulseFaint : $theme.colors.textPulseStrong,
        backgroundColor: pulseSegmentColors($theme, $isSelected, $disabled).backgroundColor,
      },
      ':disabled': pulseSegmentColors($theme, $isSelected, true),
    }),
  },
})

export const SDButtonGroupOverrides = (direction, error) => {
  return {
    Root: {
      style: ({ $theme }) => {
        return {
          flexDirection: direction ?? 'initial',
          backgroundColor: $theme.colors.bgMuted,
          width: 'auto',
          marginLeft: '0.01rem',
          border: error ? `solid 2px ${$theme.colors.errorInput}` : `solid 1px ${$theme.colors.borderGroupIdle}`,
          borderTopRightRadius: $theme.borders.radius200,
          borderBottomRightRadius: $theme.borders.radius200,
          borderBottomLeftRadius: $theme.borders.radius200,
          borderTopLeftRadius: $theme.borders.radius200,
        }
      },
    },
  }
}
export const SDButtonGroupButtonOverrides = () => {
  return {
    BaseButton: {
      style: ({ $theme, $disabled, $isSelected }) => {
        const bgColour = $isSelected ? $theme.colors.white : $theme.colors.bgMuted
        const textColor = $disabled ? $theme.colors.textBtnDisabled : $isSelected ? $theme.colors.primary400 : 'inherit'
        const border = $isSelected ? `1px solid ${$theme.colors.primaryAlt}` : '1px solid transparent'
        const hoverOutline = $disabled ? 'none' : `0.125rem solid ${$theme.colors.primaryAlt}`

        return {
          flex: '1 1 auto',
          color: textColor,
          backgroundColor: bgColour,
          border,
          borderRadius: '.375rem',
          ':hover': {
            outline: hoverOutline,
            outlineOffset: '-.125rem',
          },
          ':focus': {
            outline: hoverOutline,
            outlineOffset: '-.125rem',
          },
          ':disabled': {
            backgroundColor: bgColour,
          },
          ':disabled :hover': {
            backgroundColor: bgColour,
          },
          ':disabled :focus': {
            backgroundColor: bgColour,
          },
          ':not(:last-child)': {
            marginRight: '.1875rem',
          },
        }
      },
    },
  }
}
